"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwoFactorWithPhoneViewContainer = void 0;
var React = _interopRequireWildcard(require("react"));
var _TitleContainer = require("../TitleContainer");
var _Link = require("../../components/Link");
var _SubtitleLayout = require("../../components/SubtitleLayout");
var _ViewContainer = require("../ViewContainer");
var _tracking = require("../../utils/tracking");
var _authentication = require("../../types/authentication");
var _events = require("../../actions/events");
var _events2 = require("../../types/events");
var _FormContainer = require("./containers/FormContainer");
var _HelpContainer = require("../HelpContainer");
var _hooks = require("../../hooks");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const TwoFactorWithPhoneViewContainer = _ref => {
  let {
    useSelector,
    useDispatch
  } = _ref;
  const dispatch = useDispatch();
  const cianHost = (0, _hooks.useCianHost)({
    useSelector
  });
  React.useEffect(() => {
    (0, _tracking.trackTwoFactorPopupOpen)(_authentication.ETwoFactorType.Phone);
  }, []);
  const handleWhatForClick = React.useCallback(() => {
    (0, _tracking.trackTwoFactorWhatForClick)(_authentication.ETwoFactorType.Phone);
    dispatch((0, _events.emit)(_events2.EEventType.TwoFactorWhatForClick));
  }, [dispatch]);
  const handleCannotConfirmClick = React.useCallback(() => {
    (0, _tracking.trackTwoFactorCannotConfirmClick)(_authentication.ETwoFactorType.Phone);
    dispatch((0, _events.emit)(_events2.EEventType.TwoFactorCannotConfirmClick));
  }, [dispatch]);
  return /*#__PURE__*/React.createElement(_ViewContainer.ViewContainer, null, /*#__PURE__*/React.createElement(_TitleContainer.TitleContainer, null), /*#__PURE__*/React.createElement(_SubtitleLayout.SubtitleLayout, null, /*#__PURE__*/React.createElement("div", null, "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0451\u043D\u043D\u044B\u0439 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u044B\u0439\xA0\u0442\u0435\u043B\u0435\u0444\u043E\u043D \u0438\u0437 \u0432\u0430\u0448\u0435\u0433\u043E \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430\xA0\u0438\u043B\u0438\xA0\u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(_Link.Link, {
    href: `${cianHost}/help/security/37947?utm_source=authentication&utm_medium=organic&utm_campaign=two_factor_auth`,
    target: "_blank",
    onClick: handleWhatForClick
  }, "\u0417\u0430\u0447\u0435\u043C \u044D\u0442\u043E \u043D\u0443\u0436\u043D\u043E")), /*#__PURE__*/React.createElement(_FormContainer.FormContainer, null), /*#__PURE__*/React.createElement(_HelpContainer.HelpContainer, {
    text: "\u041D\u0435 \u043C\u043E\u0433\u0443 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C",
    onClick: handleCannotConfirmClick,
    query: {
      topic: 'Login'
    }
  }));
};
exports.TwoFactorWithPhoneViewContainer = TwoFactorWithPhoneViewContainer;